import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet";

import HeroSection from "./HeroSection";

const OverviewSection = lazy(() => import("./OverviewSection"));
const AdvantageSection = lazy(() => import("./AdvantageSection"));
const TicketBookingSection = lazy(() => import("./TicketBookingSection"));
const KeyFeaturesSection = lazy(() => import("./KeyFeaturesSection"));

const Entertainment = () => {
  return (
    <>
      <Helmet>
        <title>
          Entertainment Software & Ticketing Solutions | LENTERA Digital
          Platforms
        </title>
        <meta
          name="description"
          content=" Transform the live event experience with LENTERA’s innovative entertainment software and ticket booking system. Enjoy seamless navigation, secure payments, multi-device access and data-driven insights to enhance engagement and customer satisfaction."
        />
        <meta
          name="keywords"
          content="LENTERA entertainment platform, personalized entertainment recommendations, backend integration for events."
        />
      </Helmet>

      <HeroSection />

      <Suspense fallback={<div className="h-[400px]" />}>
        <OverviewSection />
        <AdvantageSection />
        <TicketBookingSection />
        <KeyFeaturesSection />
      </Suspense>
    </>
  );
};

export default Entertainment;
